<template>
    <div style="width: 100%;" :id="componentId">
        <multiselect 
            v-model="selectedEntities"
            :options="entities" 
            :multiple="true"
            :close-on-select="true"
            :clear-on-select="false"
            :placeholder="placeholder"
            track-by="id"
            label="text"
            @close="onCloseMultiselect"
            @remove="removeOption"
        >
            <template #option="{ option }">
                <span>
                    <v-icon v-if="option.icon" class="mr-2" small>{{ option.icon }}</v-icon>
                    {{ option.text }}<span v-if="option.suffix" class="caption ml-1">{{ option.suffix }}</span>
                </span>
            </template>
            <template #tag="{ option, remove }">
                <span class="multiselect__tag">
                    <v-icon v-if="option.icon" class="mr-2" small>{{ option.icon }}</v-icon>
                    {{ option.text }}
                    <i
                        aria-hidden="true"
                        tabindex="1"
                        class="multiselect__tag-icon"
                        @click.prevent.stop="remove(option)"
                    ></i>
                </span>
            </template>
            <template slot="noOptions">
                No options available.
            </template>
            <span 
                slot="caret"
                slot-scope="{ toggle }"
                class="arrow multiselect__select"
                @mousedown.prevent.stop="toggle"
                tabindex="-1">
            </span>
        </multiselect>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },
    props: {
        options: {
            type: Array,
            required: true // Each option should include { id, text, icon (optional) }
        },
        selectedOptions: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
            default: 'Select options...'
        }
    },
    data() {
        return {
            entities: this.options,
            selectedEntities: this.selectedOptions,
            componentId: `multi-select-${Math.random().toString(36).substring(2)}`
        };
    },
    watch: {
        selectedEntities(newSelected) {
            this.$emit('update:selected-options', newSelected);
        },
        options(newOptions) {
            this.entities = newOptions;
        },
        selectedOptions(newSelectedOptions) {
            this.selectedEntities = newSelectedOptions;
        }
    },
    methods: {
        onCloseMultiselect() {
            const caret = document.getElementById(this.componentId).querySelector('.multiselect__select');
            if (caret) caret.focus();
        },
        removeOption(removedOption) {
            // Placeholder for handling item removal logic if needed
        }
    }
};
</script>
